module.exports = __webpack_public_path__ + "static/media/logo-punto-seguido-inverted.c225d1f6.svg";